import { render, staticRenderFns } from "./FormInputRadio.vue?vue&type=template&id=2a799eb5&scoped=true&lang=pug"
import script from "./FormInputRadio.vue?vue&type=script&lang=ts"
export * from "./FormInputRadio.vue?vue&type=script&lang=ts"
import style0 from "./FormInputRadio.vue?vue&type=style&index=0&id=2a799eb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a799eb5",
  null
  
)

export default component.exports